module.exports = __webpack_public_path__ + "img/logo.342aaf08.png";